"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EConsortiumCgpStatus = void 0;
exports.EConsortiumCgpStatus = {
    en_attente: "en_attente",
    en_cours: "en_cours",
    valide: "valide",
    refuse: "refuse",
};
